import React from "react";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { sectionIds } from "./section-ids";

const title = "New Residential Solar Industry Solutions";

const Solutions = () => {
  return (
    <div className="bg-navy-dark">
      <div className="bg-gradient-to-b from-navy via-navy to-primary/70">
        <HeroSection title={title} id={sectionIds.solutions} className="py-20 sm:py-20">
          <HeroSection.Content className="space-y-10">
            <header className="text-center">
              <HeroSection.Tagline className="text-amber-500 mb-8">{title}</HeroSection.Tagline>
              <Heading tag="h2" className="mb-6 max-w-4xl mx-auto">
                <span className="text-white">Residential Solar Software for the Whole Industry</span>{" "}
                <span className="text-primary">— Not Just Installers</span>
              </Heading>
              <p className="text-lg text-gray-100 max-w-4xl mx-auto">
                Enerflo isn’t just for residential solar sales orgs, installers/EPCs, hybrid and vertically integrated
                companies. The Enerflo OS that’s powered over $15 Billion in transactions benefits other industry
                players as well, including financiers, manufacturers, distributors, insurers and investment firms.
              </p>
            </header>
          </HeroSection.Content>
        </HeroSection>
      </div>
    </div>
  );
};

export default Solutions;
